import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-sending',
  templateUrl: './password-sending.component.html',
  styleUrls: ['./password-sending.component.sass']
})
export class PasswordSendingComponent implements OnInit {
  public passwordSending:boolean=false;
  public statusOn:number=0;
  public statusRadio=[false,false]
  public type:number=0;
  @Input() forgotPasawordStatus;
  @Input() email;
  @Input() emailToSend;
  @Input() subscriber;
  @Input() productType;
  @Output() updateView = new EventEmitter<number>();

  constructor(private global:GlobalService,  private loadingScreenService :LoadingScreenService ,private services: Service,private router:Router) { }

  ngOnInit() {
  }

  changeType(type:number){
    this.statusOn=type;
    if(type==1){
      this.statusRadio[0]=true;
      this.statusRadio[1]=false;
    }
    else{
      this.statusRadio[0]=false;
      this.statusRadio[1]=true;
    }
  }
  getPasswordRecoveryBySubscriber() {
    if (this.statusOn==1 || this.statusOn==2) {
        var sms='';
        var email='';
        // var emailToService;
        if(this.statusOn==2){
          sms=this.subscriber;
        }
        else{
          email=this.emailToSend;
        }
        this.loadingScreenService.startLoading();
        this.services.getPasswordRecoveryBySubscriber(btoa(this.subscriber),btoa(email),sms).subscribe(data =>{
          this.loadingScreenService.stopLoading();
          if(data.hasError ==false){
            this.global.notif(data.response);
              this.router.navigate(['/']);
          }
          else{
            this.global.notif(data.errorDisplay);
          }
        });
    }
    else{
      this.global.notif("Por favor seleccione donde quiere recibir la contraseña temporal.");
    }
  }
}
